import React, {useState} from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import ProjectForm from "../../components/Project/ProjectForm";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import {Typography} from "@material-ui/core";
import moment from "moment-business-days";

const ProjectEdit = ({classes, project, buildings, subcontractor, apartment, uploadConfig, builtProjectNumber, defaultStatus}) => {
    project.address = project.address || '';
    project.custom_number = {
        prefix: window.companyInitials,
        suffix: '',
    }
    const builderWarrantyExpired = buildings && buildings.building_parent
        && moment().isAfter( buildings.building_parent.warranty_period_end
            && buildings.building_parent.warranty_period_end
    )
    const subcontractorWarrantyExpired = subcontractor
        && moment().isAfter(subcontractor.warranty_period_end
            && subcontractor.warranty_period_end
    )
    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('project.deficiency.' + (project.id ? 'edit' : 'add'))}
            />
            {builderWarrantyExpired && (
                <Typography color={"primary"} style={{marginBottom:10}}>
                    {i18n.get('deficiency.builder_warranty_expired')}
                </Typography>
            )}
            {subcontractorWarrantyExpired && (
                <Typography color={"primary"} style={{marginBottom:10}}>
                    {i18n.get('deficiency.subcontractor_warranty_expired',{subcontractor:subcontractor.company_name})}
                </Typography>
            )}
            <Card>
                <CardContent>
                    <ProjectForm
                        values={{...project,...buildings,...subcontractor,...apartment,'change_note': ''} || {}}
                        uploadConfig={uploadConfig}
                        builtProjectNumber={builtProjectNumber || null}
                        defaultStatus={defaultStatus}
                    />
                </CardContent>
            </Card>
        </Layout>
    )
};

export default ProjectEdit;
